// extracted by mini-css-extract-plugin
module.exports = {"container":"Tw","mProduct":"Uw","image":"Vw","description":"Ww","itemContainer":"Xw","productTitle":"Yw","brandName":"Zw","productName":"_w","itemDetails":"ax"};